module.exports = __webpack_public_path__ + "sitepen_logo_dark.19MhOb55.svg";